import { render, staticRenderFns } from "./StudentDocumentItem.vue?vue&type=template&id=b4a4bf64&scoped=true"
import script from "./StudentDocumentItem.vue?vue&type=script&lang=js"
export * from "./StudentDocumentItem.vue?vue&type=script&lang=js"
import style0 from "./StudentDocumentItem.vue?vue&type=style&index=0&id=b4a4bf64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4a4bf64",
  null
  
)

export default component.exports